import Vue from 'vue'
import VueRouter from 'vue-router'
/**
 * 重写路由的push方法
 */
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'login',
    component() {
      return import("../views/Login.vue")
    }
  },
  {
    path: '/index',
    name: 'Index',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Index.vue')
    },
    children: [
      {path: '/index', name: 'Home', component: function () {return import('../views/deviceDeliveryQuery.vue')}},
      {path: '/deviceDeliveryQuery', name: 'DeviceDeliveryQuery', component: function () {return import('../views/deviceDeliveryQuery.vue')}},
      {path: '/deviceReceiveQuery', name: 'DeviceReceiveQuery', component: function () {return import('../views/deviceReceiveQuery.vue')}},
      {path: '/addDeviceModel', name: 'AddDeviceModel', component: function () {return import('../views/addDeviceModel.vue')}},
      // {path: '/system_setting', name: 'system_setting', component: function () {return import('../views/System.vue')}},
      // {path: '/lo_ra_wan_setting', name: 'lo_ra_wan_setting', component: function () {return import('../views/LoRaWanSetting.vue')}},
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
